import { render, staticRenderFns } from "./ChbPageHeader.vue?vue&type=template&id=84289194&scoped=true"
import script from "./ChbPageHeader.vue?vue&type=script&lang=js"
export * from "./ChbPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ChbPageHeader.vue?vue&type=style&index=0&id=84289194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84289194",
  null
  
)

export default component.exports